if (!customElements.get('fr-fleet-card')) {
  customElements.define('fr-fleet-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-fleet-choice]');
        if (!button || button.closest('fr-fleet-card') !== this) return;
        this.selectVariant(button.dataset.fleetChoice);
      });
      const control = this.querySelector('[data-fleet-controls]');
      if (control) control.hidden = false;
    }

    selectVariant(variantId) {
      const template = Array.from(this.querySelectorAll('template[data-fleet-variant]'))
        .find((item) => item.dataset.fleetVariant === variantId);
      const specs = this.querySelector('[data-fleet-specs]');
      if (!template || !specs) return;
      const url = new URL(template.dataset.url, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
      specs.replaceChildren(template.content.cloneNode(true));
      const name = this.querySelector('[data-fleet-name]');
      if (name && template.dataset.name) name.textContent = template.dataset.name;
      this.querySelectorAll('[data-fleet-link]').forEach((link) => {
        link.setAttribute('href', template.dataset.url);
      });
      this.querySelectorAll('button[data-fleet-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.fleetChoice === variantId));
      });
      this.dataset.variantId = variantId;
    }
  });
}
